<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="设备编号">
            <a-input v-model="searchP.devicelist" placeholder="设备编号"></a-input>
        </a-form-item>

        <a-form-item label="消息内容">
            <a-input v-model="searchP.content" placeholder="消息内容"></a-input>
         </a-form-item>
        <a-form-item label="创建时间">
            <a-range-picker
            :show-time="{
                        hideDisabledOptions: true,
                        format:'HH:mm'
                    }" :format="dateFormat"
            v-model="timeRange"
            @change="onChange" />
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
        </a-form-item>
    </a-form>
</template>

<script>

import moment from 'moment';

export default {
    components:{

    },
    data(){
        return {
            form: this.$form.createForm(this),
            timeRange:undefined,
            dateFormat:"YYYY-MM-DD HH:mm",
            searchP:{
                devicelist:'',
                content:'',
                starttime:'',
                endtime:'',
                channelcode:'',
                messagestypecode:''
            },
        }
    },
    
    methods:{
        onChange(){
            //时间跨度不能超过3天
            let starttime =  new Date(this.timeRange[0]).getTime();
            let endtime = new Date(this.timeRange[1]).getTime();
            let timeDiff = endtime - starttime;
            if(timeDiff > (3*24*60*60*1000)){
                this.message.error('时间跨度不能超3天')
                starttime = endtime - (24*60*60*1000*3);
            }
            starttime = new Date(starttime).Format("yyyy-MM-dd hh:mm");
            endtime = new Date(endtime).Format("yyyy-MM-dd hh:mm");
            this.timeRange = [moment(starttime, this.dateFormat), moment(endtime, this.dateFormat)];
            this.searchP.starttime = starttime;
            this.searchP.endtime =endtime
            console.log(this.timeRange)
        },
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        },
        handleChange(item){
            this.searchP.passwaytype = item.passwaytype;
        },
        getDefaultRange(){
            let now = new Date();
            let sTime = new Date(new Date(now).getTime() - (3*24*60*60*1000) ).Format("yyyy-MM-dd hh:mm");
            let eTime = now.Format("yyyy-MM-dd hh:mm");
            this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)];
            this.onChange();
        }
    },
    mounted(){
        this.getDefaultRange()

        this.handleSubmit()
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

